import React from 'react';
import { Box } from '@mui/material';

const Circle = ({ 
  width = 60,
  height = 60,
  backgroundColor = 'transparent',
  borderWidth = 1,
  borderColor = '#000000',
  opacity = 1
}) => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        backgroundColor,
        border: `${borderWidth}px solid ${borderColor}`,
        borderRadius: '50%',
        opacity,
        boxSizing: 'border-box'
      }}
    />
  );
};

export default Circle;